import { object, string } from 'yup';

export const externalCommentValidation = object().shape({
  externalComment: string().required('Comment required')
});

export const externalCommentDefaults = { externalComment: '' };
